const logoGreta = process.env.PUBLIC_URL + "/Logo-GRETA-Grand-Hainaut-500.jpg";
const logoGreta2 = process.env.PUBLIC_URL + "/logo_partenaires.png";
const logoMattCornic = "MattCornicDev";
export { logoGreta, logoGreta2, logoMattCornic };